import {
  HTTP_BUDGETS_FETCHING,
  HTTP_BUDGETS_SUCCESS,
  HTTP_BUDGETS_FAILED,
  server,
  OK,
  YES,
  HTTP_BUDGETS_RESET,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";
import { async } from "q";
import Axios from "axios";

export const setStateBudgetsToFetching = () => ({
  type: HTTP_BUDGETS_FETCHING,
});

export const setStateBudgetsToSuccess = (payload) => ({
  type: HTTP_BUDGETS_SUCCESS,
  payload,
});

export const setStateBudgetsToFailed = (payload) => ({
  type: HTTP_BUDGETS_FAILED,
});

export const clearBudgets = () => {
  return async (dispatch) => {
    dispatch(
      setStateBudgetsToSuccess({
        data: [],
      })
    );
  };
};

export const getBudgetsById = (country, depts, brand, company, year, secid) => {
  return async (dispatch) => {
    dispatch(setStateBudgetsToFetching());

    try {
      const result = await httpClient.get(
        `${server.BUDGETS_URL}/${country}/${depts}/${brand}/${company}/${year}/${secid}`
      );

      dispatch(
        setStateBudgetsToSuccess({
          // data: result.data.result,
          // id: result.data.result[0].BUDGETSD_SID,
          // appid: result.data.result[0].BUDGETS_APPROVER,
          // actid: result.data.result[0].BUDGETS_ACTIVE,
          data: result.data,
          id: result.data[0].BUDGETSD_SID,
          appid: result.data[0].BUDGETS_APPROVER,
          actid: result.data[0].BUDGETS_ACTIVE,
        })
      );

      return Promise.resolve(result.data[0].BUDGETSD_SID);
    } catch (error) {
      // console.log("aaaaa");
      dispatch(setStateBudgetsToFailed());

      return Promise.reject(error.message);
    }
  };
};

export const resetBudget = () => {
  return (dispatch) => {
    dispatch({ type: HTTP_BUDGETS_RESET });
  };
};
